<template>
  <component :is="component" v-if="isVisible" class="inline-block">
    <o-chip
      flat
      variant="info"
      :icon="editable ? 'chevronDown' : null"
      :size="size"
      icon-after
      placement="bottom-end"
    >
      {{ $t('components.reservation.elements.statusRequestType.label', { description: $t(requestTypeLabel) }) }}
    </o-chip>

    <template v-if="editable" #content>
      <o-dropdown-item
        v-for="(item, key) in requestTypeOptions"
        :key="key"
        @click="currentValue = item.value"
      >
        {{ $t(item.label) }}
      </o-dropdown-item>
    </template>
  </component>
</template>

<script setup lang="ts">
import {
  ODropdownItem,
} from '@/components/elements'

import { ReservationCustomerRequestType, ReservationCustomerRequestTypeLabels } from '@/_api/models/reservation'

interface Props {
  modelValue: number | Record<string, any>
  editable?: boolean
  size?: string | null
}

interface Emits {
  (e: 'update:modelValue', value: any): void
}

const props = withDefaults(defineProps<Props>(), {
  editable: false,
  size: null,
})

const emit = defineEmits<Emits>()

const currentValue = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

const requestTypeLabel = computed(() => {
  const val = (typeof props.modelValue === 'object' ? props.modelValue?.value : props.modelValue) as ReservationCustomerRequestType
  return ReservationCustomerRequestTypeLabels[val] || ''
})

const requestTypeOptions = computed(() => {
  return Object.values(ReservationCustomerRequestType)
    .filter((value): value is ReservationCustomerRequestType => typeof value === 'number')
    .map((value) => ({
      value,
      label: ReservationCustomerRequestTypeLabels[value],
    }))
})

const component = computed(() => {
  return props.editable ? 'o-dropdown' : 'div'
})

const isRequestTypeNone = computed(() => {
  const val = typeof props.modelValue === 'object' ? props.modelValue?.value : props.modelValue
  return val === ReservationCustomerRequestType.none
})

const isVisible = computed(() => {
  return !isRequestTypeNone.value || props.editable
})
</script>
